import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ads/attribution-capture.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/open-sans/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/spline-sans/index.css");
;
import(/* webpackMode: "eager" */ "/app/assets/styles/main.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
